import replaceSingeQuotes from './replace-single-quotes';

export function getPersonalizedTagCancer(cancer: string): string {
  return `cancer-${replaceSingeQuotes(cancer).toLowerCase()}`;
}
